import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

import { get } from 'lodash';

/*************************************************************/

/**
 * @type {class}
 * @desc memberAddEditAddress defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { memberAddEditAddressService } from 'services/memberAddEditAddress';
 *
 * // create service instance and send/cancel request
 * const memberAddEditAddressService = new memberAddEditAddressService();
 * const result = await memberAddEditAddressService.fetchData( '<user-id>' ); // fetch data
 * memberAddEditAddressService.cancel(); // cancel an active request
 */
export class AddCreditService extends HttpService {

    // fetch form data
    submitAddCredit( { url, data } ) {
        try {
            return this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );
        } catch( error ) {
           console.log('error');
           return {};
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
